import HObject from '@/core/HObject.js'

export default class HApp {
  constructor(name) {
    this.name = name
    this.registered = false

    this.user_id = ''
    this.user_email = ''
    this.dimension_id = ''
    this.dimension = ''

    this.content = {}

    this.content.position = {}
    this.content.hObjects = []

    this.content.position.x = 0
    this.content.position.z = 0
    this.content.position.y = 0
  }

  makeHObject (name, type, allowRegistration, x, z, y, ry) {
    let hObject = new HObject(name, type, allowRegistration)
    hObject.position.x = x
    hObject.position.y = y
    hObject.position.z = z
    hObject.rotation.y = ry

    this.addHObject(hObject)

    return hObject
  }

  makeArrayHObject (name, type, allowRegistration, x, z, y, ry, n, distanceX, distanceZ, distanceY) {
    let array = []
    for (let i = 0; i < n; i++) {
      let hObject = new HObject(name + '_' + i, type, allowRegistration)

      let dX = distanceX * i
      let dY = distanceY * i
      let dZ = distanceZ * i

      hObject.position.x = x + dX
      hObject.position.y = y + dY
      hObject.position.z = z + dZ
      hObject.rotation.y = ry

      this.addHObject(hObject)

      array.push(hObject)
    }

    return array
  }

  updateMeshesPositionRotation () {
    for (let key in this.content.hObjects) {
      this.content.hObjects[key].updateMeshesPositionRotation()
    }
  }

  addHObject (hObject) {
    hObject.hAppName = this.name
    let index = this.content.hObjects.findIndex(element => element.name === hObject.name)
    if (index >= 0) { // hObject existente y se sobreescribe
      this.content.hObjects[index] = hObject
    } else { // hObject nuevo
      this.content.hObjects.push(hObject)
    }
  }

  getHObjectByName (name) {
    return this.content.hObjects.find(element => element.name === name)
  }
}



// WEBPACK FOOTER //
// ./src/core/HApp.js